import { render, staticRenderFns } from "./TaskStats.vue?vue&type=template&id=15f8da70&scoped=true"
import script from "./TaskStats.vue?vue&type=script&lang=js"
export * from "./TaskStats.vue?vue&type=script&lang=js"
import style0 from "./TaskStats.vue?vue&type=style&index=0&id=15f8da70&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8da70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VAlert,VCard,VCardTitle,VContainer,VDataTable,VFlex,VIcon,VLayout,VOverlay})
